import React from "react"

import { Row, Col, Form, Button } from "react-bootstrap"
import { insuranceType } from "../../data/formOptions"

const MultiType = props => {
  const { values, setType, nextStep } = props
  

  const setTypeAndNext = type => {
    setType(type)
    nextStep()
  }

  return (
    <div style={{ textAlign: "center" }}>
      {/* <---------------Q1--------------->*/}
      <Row style={{ justifyContent: "center" }}>
        <Col xs={12} sm={6}>
          <Form.Label className="button-question">
            Type of insurance?
          </Form.Label>

          {/* <---------------BUTTON--------------->*/}
          <Row>
            <Col sm={4} xs={4} style={{ textAlign: "center" }}>
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => {
                    setTypeAndNext(insuranceType.level)
                  }}
                  active={values.type === insuranceType.level ? true : false}
                >
                  <i className="fas fa-umbrella fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Level Term</Form.Label>
            </Col>
            {/* <---------------BUTTON--------------->*/}
            <Col sm={4} xs={4} style={{ textAlign: "center" }}>
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setTypeAndNext(insuranceType.mortgage)}
                  active={values.type === insuranceType.mortgage ? true : false}
                >
                  <i className="fas fa-home fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Mortgage</Form.Label>
            </Col>
            {/* <---------------BUTTON--------------->*/}
            <Col sm={4} xs={4} style={{ textAlign: "center" }}>
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setTypeAndNext(insuranceType.wol)}
                  active={values.type === insuranceType.wol ? true : false}
                >
                  <i className="fas fa-heart fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Whole of Life</Form.Label>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default MultiType
